import { useSelectedOrganisation } from "xplatform_shell/useSelectedOrganisation";

export const MANAGE_RELEASE_NOTES = "admin.releasenotes.manage";

/**
 * Effective permissions for the selected organisation, from the shell.
 *
 * Deny while the organisation is still null, and never fall back to the shell's
 * own `hasPermission`, which can default to true. The authoring screen is the
 * only permissioned surface in this module, so a permissive default here would
 * render a form whose every call 403s.
 */
export const useReleaseNotesPermissions = () => {
  const { organisation } = useSelectedOrganisation();

  const effectivePermissions = organisation?.effectivePermissions ?? [];

  const hasPermission = (permission: string): boolean =>
    organisation != null && effectivePermissions.includes(permission);

  return {
    /** Null until the shell has resolved, so callers can avoid flashing a denial. */
    resolved: organisation != null,
    effectivePermissions,
    canManageReleaseNotes: hasPermission(MANAGE_RELEASE_NOTES),
  };
};
